import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { get } from "../../utils/api";

const ShipAutocomplete = ({
  title,
  value,
  onChange,
  error,
  disable,
  placeholder,
  titleDisabled = false,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const handleInputChange = (event, newInputValue) => {
    onChange(newInputValue);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newTimeout = setTimeout(() => {
      if (newInputValue) {
        fetchShips(newInputValue);
      } else {
        setOptions([]);
      }
    }, 500);

    setDebounceTimeout(newTimeout);
  };

  const fetchShips = async (query) => {
    try {
      setLoading(true);
      let response = await get(
        `/scope3/shipTransportation/search/ships?search=${query}&limit=10`
      );
      console.log("first", response?.data?.data);
      setOptions(response?.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ships:", error);
      setLoading(false);
    }
  };

  return (
    <Box>
      {!titleDisabled && (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            mt: "1rem",
          }}
        >
          {title}
        </Typography>
      )}

      <Autocomplete
        freeSolo
        options={options}
        disabled={disable}
        getOptionLabel={(option) => option}
        filterOptions={(x) => x || []}
        onInputChange={handleInputChange}
        onChange={(event, newValue) => onChange(newValue)} // Update parent state
        size="small"
        inputValue={value}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            placeholder={placeholder}
            error={!!error}
            helperText={
              !titleDisabled &&
              error && <Typography color="error">{error}</Typography>
            }
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default ShipAutocomplete;
